export const API_ENDPOINT = {
  V1_CERTIFICATION: '/v1/certification',
  V1_CERTIFICATION_STATUS: '/v1/certification/status',
} as const;

export const STATUS = {
  ALL: 'ALL',
  CAREER: 'CAREER',
  INSTITUTION: 'INSTITUTION',
  NO_AUTH: 'NO_AUTH',
};
